import { applyMiddleware, createStore } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { createLogger } from 'redux-logger';
import { combineReducers } from 'redux';
import WindowReducers from './reducers/windowReducers';
import SessionReducers from './reducers/sessionReducers';

export default (function(env) {
    const reducers = {
        win: WindowReducers,
        session: SessionReducers
    };
    switch(NODE_ENV) {
        // Used when production is specified for NODE_ENV;
        case 'PRODUCTION':
            return createStore(
                combineReducers(reducers),
                applyMiddleware(apiMiddleware)
            );

        // DEVELOPMENT and also the default store.
        default:
            return createStore(
                // All reducers.
                combineReducers(reducers),

                // All middleware.
                applyMiddleware(
                    apiMiddleware,
                    createLogger()
                )
            );
    }
})(NODE_ENV)
